import { MuggleMixin, MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import FormFieldComponent from '../form-field/form-field.vue.js';
import '../form-field/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let PeekPasswordComponent = class extends Mixins(MuggleMixin, MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isShown = false;
    this.focused = false;
    this.timer = null;
  }
  togglePassword() {
    this.isShown = !this.isShown;
    this.focused = false;
    this.$nextTick(() => {
      this.focused = true;
    });
  }
  maskPassword(active) {
    this.timer && clearTimeout(this.timer);
    this.isShown = active;
    active && (this.timer = setTimeout(() => {
      this.isShown = false;
    }, 3e3));
  }
  onShownChange(shown) {
    this.isShown = shown;
  }
};
__decorateClass([
  Prop(Boolean)
], PeekPasswordComponent.prototype, "unmaskPassword", 2);
__decorateClass([
  Prop({ type: Boolean, default: false })
], PeekPasswordComponent.prototype, "shown", 2);
__decorateClass([
  Watch("shown", { immediate: true })
], PeekPasswordComponent.prototype, "onShownChange", 1);
PeekPasswordComponent = __decorateClass([
  Component({
    name: "ui-peek-password",
    inheritAttrs: false,
    components: {
      "ui-form-field": FormFieldComponent
    }
  })
], PeekPasswordComponent);

export default PeekPasswordComponent;
